// @flow
import { ApiBase } from 'api/api'
import { makeDeleteRequest, makePostRequest } from 'api/fetchCalls'
import type { ExportFile, ExportFileCreateProps } from 'types/exports'

export const addExportFile = async (
  export_id: string,
  data: ExportFileCreateProps
): Promise<ExportFile> => {
  return await makePostRequest(`${ApiBase}/exports/${export_id}/files`, {
    body: JSON.stringify(data),
  })
}

export const deleteExportFile = async (id: string): Promise<void> => {
  return await makeDeleteRequest(`${ApiBase}/exports/files/${id}`)
}
